import { BasicDragContainerComponent } from "../../../ui/containers/DragContainer"
import { useSortable } from "@dnd-kit/sortable"
import { CSS } from "@dnd-kit/utilities"
import { FC } from "react"
import { NeutralSetting } from "src/types"

interface SortableContainerComponentProps {
  id: string
  index: number | null
  selected: boolean
  disabled?: boolean
  drag?: boolean
  onClick?: () => void
  handleRemove?: () => void
  isCorrect?: boolean
  children?: JSX.Element | JSX.Element[]
  isNeutralSetting?: NeutralSetting
}

export const SortableContainerComponent: FC<
  SortableContainerComponentProps
> = ({ id, index, children, isNeutralSetting, ...props }) => {
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({ id })
  const style = {
    transform: CSS.Transform.toString(transform),
    transition
  }
  return (
    <BasicDragContainerComponent
      ref={setNodeRef}
      index={index}
      assigned={true}
      style={style}
      accessibility={{
        "aria-label": props.drag ? "" : "unselected"
      }}
      isNeutralSetting={isNeutralSetting}
      {...attributes}
      {...listeners}
      {...props}
    >
      {children}
    </BasicDragContainerComponent>
  )
}
